// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    activeRoboCustomer: null,
    checkStatus: 0,
    newRoboCustomer: null,
    testExpired: null,
    unSignedTest: null,
    testInProgress: null,
    nonSuitableTest: null,
    canRepeatTest: false,
    isFetchingCheckStatus: false,
    checkStatusFetched: false,
    error: null,
    hasData: false,
    zeroCommission: false,
    expirationDate: null,
});

const RACheckStatus = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_CHECK_STATUS_REQUEST:
            return state.set('isFetchingCheckStatus', true);
        case actionTypes.RA_CHECK_STATUS_SUCCESS:
            const {
                activeRoboCustomer,
                checkstatus,
                newRoboCustomer,
                testExpired,
                unSignedTest,
                testInProgress,
                nonSuitableTest,
                canRepeatTest,
                zeroCommissions,
                expirationDate,
            } = action.payload;
            return state.merge({
                activeRoboCustomer: activeRoboCustomer,
                checkStatus: checkstatus,
                newRoboCustomer: newRoboCustomer,
                testExpired: testExpired,
                unSignedTest: unSignedTest,
                testInProgress: testInProgress,
                nonSuitableTest: nonSuitableTest,
                canRepeatTest: canRepeatTest,
                checkStatusFetched: true,
                isFetchingCheckStatus: false,
                hasData: true,
                zeroCommission: zeroCommissions,
                expirationDate: expirationDate,
            });
        case actionTypes.RA_CHECK_STATUS_FAILURE:
            return state.merge({
                checkStatusFetched: true,
                error: action.payload,
                isFetchingCheckStatus: false,
            });
        default:
            return state;
    }
};

module.exports = RACheckStatus;
